import { Component, EventEmitter, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import Config from '../../../config/config.json';
import { DevAuthService } from '../../../services/dev-service/dev-auth/dev-auth.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent {
  showLandingPAge = Config.LoginForm;

  username = '';
  password = '';
  /** Custom reveal control so visibility toggle is consistent across browsers (Edge’s native eye is hidden in styles). */
  passwordVisible = false;
  isLoading = false;
  errorMessage = '';

  @Output() loginSuccess = new EventEmitter<void>();

  constructor(private devAuthService: DevAuthService) {}

  togglePasswordVisible(): void {
    this.passwordVisible = !this.passwordVisible;
  }

  /**
   * Prefer service-mapped messages; for other HTTP failures surface API/detail text or status.
   */
  private resolveLoginErrorMessage(err: unknown): string {
    const e = err as { error?: { message?: string }; message?: string; status?: number };
    if (e?.error?.message) {
      return e.error.message;
    }
    if (err instanceof HttpErrorResponse) {
      const body = err.error as Record<string, unknown> | string | null | undefined;
      if (typeof body === 'string' && body.trim()) {
        return body;
      }
      if (body && typeof body === 'object') {
        const detail = body['detail'] as Record<string, unknown> | undefined;
        const detailErr = detail?.['error'];
        if (detail && typeof detailErr === 'string' && detailErr.trim()) {
          return detailErr;
        }
        const msg = body['message'];
        if (typeof msg === 'string' && msg.trim()) {
          return msg;
        }
      }
      return err.message || `Request failed (${err.status}).`;
    }
    return e?.message || 'Login failed. Please check your credentials.';
  }

  onLogin(): void {
    if (!this.username.trim() || !this.password.trim()) {
      this.errorMessage = 'Email id and password are required.';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    this.devAuthService.authenticateWithCredentials(this.username, this.password).subscribe({
      next: () => {
        this.isLoading = false;
        this.devAuthService.updateEnvironmentWithCookies();
        this.loginSuccess.emit();
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = this.resolveLoginErrorMessage(err);
      }
    });
  }
}
